const initBlockAnimation = async( $block ) => {
	const { gsap } = await import( "gsap" );
	const $heading = $block.find( ".js-heading" );
	const $title = $block.find( ".js-section-title" );
	const $description = $block.find( ".js-section-description" );
	const $stepsContainer = $block.find( ".js-steps" );
	const $steps = $block.find( ".js-step" );

	// Set Initial State
	gsap.set( $title[0], { opacity: 0 } );
	gsap.set( $description[0], { opacity: 0, y: -50 } );

	$steps.each( function() {
		const $step = $( this );
		const $title = $step.find( ".js-title" );
		const $description = $step.find( ".js-description" );
		const $logo = $step.find( ".js-logo" );

		gsap.set( [$title[0], $logo[0]], { opacity: 0 } );
		gsap.set( [$description[0]], { opacity: 0, y: -50 } );
	} );

	const animateElement = ( entry ) => {
		const $block = $( entry.target );
		const $title = $block.find( ".js-section-title" );
		const $description = $block.find( ".js-section-description" );
		const tl = gsap.timeline();

		tl
			.to( $title[0], { opacity: 1, duration: .5, delay: .5 } )
			.to( $description[0], { opacity: 1, y: 0, duration: .5 } );
	};

	const animateSteps = ( entry ) => {
		const $block = $( entry.target );
		const $steps = $block.find( ".js-step" );
		const $scroller = $block.find( ".js-scroller" );

		const animateStep = ( entry ) => {
			const $step = $( entry.target );
			const $title = $step.find( ".js-title" );
			const $description = $step.find( ".js-description" );
			const $logo = $step.find( ".js-logo" );
			const tl = gsap.timeline();

			tl
				.to( [$title[0], $logo[0]], { opacity: 1, duration: .5, delay: .5 } )
				.to( $description[0], { opacity: 1, y: 0, duration: .5 } );
		};

		const stepObserver = new IntersectionObserver( ( entries, observer ) => {
			entries.forEach( entry => {
				if ( entry.isIntersecting ) {
					animateStep( entry );
					observer.unobserve( entry.target );
				}
			} );
		}, {
			root: $scroller[0],
			rootMargin: "0px",
			threshold: 1
		} );

		$steps.each( function() {
			stepObserver.observe( this );
		} );
	};

	const headingObserver = new IntersectionObserver( ( entries, observer ) => {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				animateElement( entry );
				observer.unobserve( entry.target );
			}
		} );
	}, {
		root: document,
		rootMargin: "0px",
		threshold: 1
	} );
	const stepsObserver = new IntersectionObserver( ( entries, observer ) => {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				animateSteps( entry );
				observer.unobserve( entry.target );
			}
		} );
	}, {
		root: document,
		rootMargin: "0px",
		threshold: .25
	} );

	$heading.each( function() {
		headingObserver.observe( this );
	} );
	$stepsContainer.each( function() {
		stepsObserver.observe( this );
	} );
};

const initScroller = ( $block ) => {
	const $wpadminbar = $( "#wpadminbar" );
	const $header = $( ".section-header" );
	let topOffset = 0;
	if ( $header.length ) {
		topOffset = $header[0].getBoundingClientRect().height;
	}

	if ( $wpadminbar.length ) {
		topOffset += $wpadminbar[0].getBoundingClientRect().height;
	}

	const $inner = $block.find( ".js-inner" );
	const $scroller = $block.find( ".js-scroller" );
	const $stepsContainer = $block.find( ".js-steps-container" );
	const $steps = $block.find( ".js-steps" );

	const height = $scroller.height();

	$inner.css( "height", height );
	$scroller.addClass( "fullscreen" );

	const calcPosition = () => {
		const scroll = $( window ).scrollTop();
		const offset = $block.offset().top;
		const scrollTop = scroll - offset + topOffset;
		const { height: stepsContainerHeight } = $stepsContainer[0].getBoundingClientRect();
		const { height: stepsHeight } = $steps[0].getBoundingClientRect();

		const maxScroll = stepsHeight - stepsContainerHeight;

		if ( scrollTop > 0 ) {
			let translateValue = Math.min( scrollTop, maxScroll );
			$steps.css( "transform", `translateY(${ -translateValue }px)` );
		} else {
			$steps.css( "transform", "translateY(0px)" );
		}
	};

	const destroy = () => {
		$inner.removeAttr( "style" );
		$steps.removeAttr( "style" );
		$scroller.removeClass( "fullscreen" );

		$( window ).off( "scroll", calcPosition );
	};

	$( window ).on( "scroll", calcPosition );

	return {
		reInit() {
			destroy();
			initScroller( $block );
		}
	};
};

const initBlock = async function( $block ) {
	if ( !$block.length ) {return;}
	const scroller = initScroller( $block );

	await initBlockAnimation( $block );

	$( window ).on( "resize", scroller.reInit );
};

themeUtils.loadBlock( initBlock, "insurance-process", ".section-insurance-process" );
